// Copyright (c) 2017 Deere & Company

import './approve-deny-button-group.scss';
import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';

const ApproveDenyButtonGroup = props =>
    <section className='button-group'>
        {props.isShowReturnButton &&
            <button
                className='secondary'
                disabled={props.isReturnDisabled}
                onClick={props.onReturn}
            >
                <FormattedMessage id='RETURN'/>
            </button>
        }
        <button
            className='secondary'
            disabled={props.isDenyDisabled}
            onClick={props.onDeny}
        >
            <FormattedMessage id='DENY'/>
        </button>
        <button
            className='primary'
            disabled={props.isApproveDisabled}
            onClick={props.onApprove}
        >
            <FormattedMessage id='APPROVE'/>
        </button>
    </section>;

ApproveDenyButtonGroup.displayName = 'ApproveDenyButtonGroup';
ApproveDenyButtonGroup.propTypes = {
    isApproveDisabled: PropTypes.bool,
    isDenyDisabled: PropTypes.bool,
    isReturnDisabled: PropTypes.bool,
    isShowReturnButton: PropTypes.bool,
    onApprove: PropTypes.func.isRequired,
    onDeny: PropTypes.func.isRequired,
    onReturn: PropTypes.func.isRequired
};

export default ApproveDenyButtonGroup;



// WEBPACK FOOTER //
// ./src/tcsm/shared/components/approve-deny-button-group.js